module.exports = __webpack_public_path__ + "static/media/guide2.1ac88cc5.png";